import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow, MaskLine } from "./Primitives";
import { CONTACT } from "../../lib/site";

const PILLARS = [
  ["Avaliação", "Cada plano começa entendendo seu histórico, rotina e limitações."],
  ["Técnica", "Execução correta antes de carga. Segurança é inegociável."],
  ["Progressão", "Ajustes constantes para você evoluir semana após semana."],
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="sobre" ref={ref} className="relative px-5 py-24 md:px-10 md:py-40" data-testid="about-section">
      <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <Reveal>
            <div className="relative aspect-[3/4] overflow-hidden bg-[var(--ink-3)] clip-notch">
              <motion.img style={{ y, scale: 1.2 }} src="/img/carlos.jpg" alt="Carlos Motta, personal trainer"
                className="h-full w-full object-cover object-top" data-testid="about-image" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c]/90 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 flex items-center gap-2 bg-[var(--bone)] px-3 py-2 font-mono text-xs uppercase tracking-[0.15em] text-[#0a0a0c]" data-testid="about-cref-badge">
                <BadgeCheck className="h-4 w-4 text-[var(--red)]" /> {CONTACT.cref}
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-10">
          <Eyebrow index="01">Sobre</Eyebrow>
          <h2 className="mt-8 font-display text-5xl font-900 uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
            <MaskLine inView>Carlos</MaskLine>
            <MaskLine inView delay={0.1}><span className="text-[var(--red)]">Motta.</span></MaskLine>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-10 max-w-xl text-lg leading-relaxed text-zinc-300 md:text-xl">
              Personal trainer dedicado a transformar treino em resultado. Atendimento presencial, consultoria online e mista — com atenção especial ao treinamento feminino — sempre com acompanhamento próximo e um plano feito sob medida para você.
            </p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-zinc-400" data-testid="about-bio">
              Sou profissional de Educação Física e pós-graduando em Treinamento Feminino, e busco unir conhecimento técnico e cuidado genuíno para que você treine com segurança, confiança e propósito. Mais do que prescrever treinos, quero ajudar você a reconhecer seu potencial, superar seus limites e construir resultados que façam sentido para a sua vida. Porque alcançar seus objetivos é importante, mas ter um processo bem orientado para chegar até eles faz toda a diferença.
            </p>
          </Reveal>

          <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-3">
            {PILLARS.map(([t, d], i) => (
              <Reveal key={t} delay={0.1 * i} className="bg-[var(--ink)] p-6" >
                <div className="font-mono text-xs text-[var(--red)]">0{i + 1}</div>
                <div className="mt-4 font-display text-2xl font-800 uppercase">{t}</div>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
